import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import AddAndEditFood from "../pages/Food/addFood/AddAndEditFood";
import Contents from "../pages/Contents/Contents";
import Categories from "../pages/Category/Categories";
import CategorySorting from "../pages/Category/CategorySorting";
import NavbarAndSidebar from "../pages/NavbarAndSidebar";
import FrequentlyServices from "../pages/FrequentlyServices/FrequentlyServices";
import Foods from "pages/Food/Foods";
import FoodSorting from "pages/Food/FoodSorting";
import AddAndEditCategory from "pages/Category/addCategory/AddAndEditCategory";
import AddAndEditContent from "pages/Contents/addContent/AddAndEditContent";
import CopyRightMessage from "layouts/CopyRightMessage/CopyRightMessage";
import Login from "pages/Login/Login";
import HowToUsePanel from "pages/HowToUsePanel/HowToUsePanel";
import Locations from "pages/Location/Locations";
import AddAndEditLocation from "pages/Location/addLocation/AddAndEditLocation";
import LocationSorting from "pages/Location/LocationSorting";
import LocationGallery from "pages/Location/LocationGallery";
import SocialMedia from "pages/SocialMedia/SocialMedia";
import AddAndEditSocialMedia from "pages/SocialMedia/addSocialMedia/AddAndEditSocialMedia";
import SocialMediaSorting from "pages/SocialMedia/SocialMediaSorting";
import AddAndEditAboutUs from "pages/AboutUs/AddAndEditAboutUs";
import ImageGalleries from "pages/ImageGallery/ImageGalleries";
import AddAndEditImageGallery from "pages/ImageGallery/addImageGallery/AddAndEditImageGallery";
import ImageGallerySorting from "pages/ImageGallery/ImageGallerySorting";
const ProjectRoutes = () => {
  return (
    <Router>
      <NavbarAndSidebar />

      <Routes>
        <Route index element={<FrequentlyServices />} />
        <Route path="/foods" element={<Foods />} />
        <Route path="/foods/add" element={<AddAndEditFood />} />
        <Route path="/foods/edit/:foodId" element={<AddAndEditFood />} />
        <Route path="/foods/sorting" element={<FoodSorting />} />
        <Route path="/categories" element={<Categories />} />
        <Route path="/categories/add" element={<AddAndEditCategory />} />
        <Route path="/categories/edit/:categoryId" element={<AddAndEditCategory />} />
        <Route path="/categories/sorting" element={<CategorySorting />} />
        <Route path="/contents" element={<Contents />} />
        <Route path="/contents/add" element={<AddAndEditContent />} />
        <Route
          path="/contents/edit/:contentId"
          element={<AddAndEditContent />}
        />
        <Route path="/locations" element={<Locations />} />
        <Route path="/locations/add" element={<AddAndEditLocation />} />
        <Route path="/locations/edit/:locationId" element={<AddAndEditLocation />} />
        <Route path="/locations/sorting" element={<LocationSorting />} />
        <Route path="/locations/gallery" element={<LocationGallery />} />
        <Route path="/social-media" element={<SocialMedia />} />
        <Route path="/social-media/add" element={<AddAndEditSocialMedia />} />
        <Route path="/social-media/edit/:socialMediaId" element={<AddAndEditSocialMedia />} />
        <Route path="/social-media/sorting" element={<SocialMediaSorting />} />
        <Route path="/about-us" element={<AddAndEditAboutUs />} />
        <Route path="/image-galleries" element={<ImageGalleries />} />
        <Route path="/image-galleries/add" element={<AddAndEditImageGallery />} />
        <Route path="/image-galleries/edit/:imageGalleryId" element={<AddAndEditImageGallery />} />
        <Route path="/image-galleries/sorting" element={<ImageGallerySorting />} />
        <Route path="/login" element={<Login />} />
        <Route path="/learn-how-to-use-panel" element={<HowToUsePanel />} />
        {/* notfound page */}
        <Route path="*" element={<FrequentlyServices />} />
      </Routes>
      <CopyRightMessage />
    </Router>
  );
};

export default ProjectRoutes;
